import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RecebivelItem from './RecebivelItem';
import { FaList, FaThLarge } from 'react-icons/fa';
import dayjs from 'dayjs';
import Button from '../common/Button'; // Importando o componente genérico

function RecebiveisList({ recebiveis, onStatusChange, onDelete }) {
  const [viewMode, setViewMode] = useState('grid'); // Alternar entre 'grid' e 'list'
  const [currentPage, setCurrentPage] = useState(1);
  const [updatedRecebiveis, setUpdatedRecebiveis] = useState(recebiveis); // State para armazenar os recebíveis atualizados
  const itemsPerPage = 20;

  // Função para agrupar os recebíveis por mês e ano
  const groupByMonth = (recebiveis) => {
    return recebiveis.reduce((acc, recebivel) => {
      const monthYear = dayjs(recebivel.dataRecebimento).format('MMMM YYYY');
      if (!acc[monthYear]) {
        acc[monthYear] = [];
      }
      acc[monthYear].push(recebivel);
      return acc;
    }, {});
  };

  const groupedRecebiveis = groupByMonth(updatedRecebiveis);

  const paginatedGroups = Object.keys(groupedRecebiveis)
    .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
    .reduce((acc, monthYear) => {
      acc[monthYear] = groupedRecebiveis[monthYear];
      return acc;
    }, {});

  const handleViewChange = (mode) => setViewMode(mode);
  const handlePageChange = (page) => setCurrentPage(page);

  const handleSave = (updatedRecebivel) => {
    const updatedList = updatedRecebiveis.map((recebivel) =>
      recebivel.id === updatedRecebivel.id ? updatedRecebivel : recebivel
    );
    setUpdatedRecebiveis(updatedList);
  };

  return (
    <div className="recebiveis-container">
      {/* Controle de Visualização */}
      <div className="flex justify-between items-center mb-4">
        <div className="flex space-x-2">
          <Button
            type="default"
            label={<FaThLarge />}
            onClick={() => handleViewChange('grid')}
            className={`p-2 rounded-lg transition-colors ${
              viewMode === 'grid'
                ? 'text-white bg-blue-600'
                : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
            }`}
          />
          <Button
            type="default"
            label={<FaList />}
            onClick={() => handleViewChange('list')}
            className={`p-2 rounded-lg transition-colors ${
              viewMode === 'list'
                ? 'text-white bg-blue-600'
                : 'bg-gray-200 text-gray-600 hover:bg-gray-300'
            }`}
          />
        </div>
        <div className="text-sm text-gray-700">
          Página {currentPage} de{' '}
          {Math.ceil(Object.keys(groupedRecebiveis).length / itemsPerPage)}
        </div>
      </div>

      {/* Renderização dos Recebíveis por Mês */}
      <div
        className={`recebiveis-list ${
          viewMode === 'grid'
            ? 'grid grid-cols-1 lg:grid-cols-5 gap-4'
            : 'flex flex-col space-y-4'
        }`}
      >
        {Object.entries(paginatedGroups).map(([monthYear, group]) => (
          <div key={monthYear} className="mb-6">
            <h2 className="text-lg font-semibold text-gray-800 mb-4">
              {monthYear}
            </h2>
            <div
              className={`${
                viewMode === 'grid' ? 'grid grid-cols-1 gap-4' : 'space-y-4'
              }`}
            >
              {group.map((recebivel) => (
                <RecebivelItem
                  key={recebivel.id}
                  recebivel={recebivel}
                  onStatusChange={onStatusChange}
                  onDelete={onDelete}
                  onSave={handleSave}
                />
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Paginação */}
      <div className="flex justify-between items-center mt-6">
        <Button
          type="default"
          label="Anterior"
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-4 py-2 bg-gray-300 text-gray-600 rounded-lg hover:bg-gray-400 transition-colors"
          disabled={currentPage === 1}
        />
        <Button
          type="default"
          label="Próximo"
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-4 py-2 bg-gray-300 text-gray-600 rounded-lg hover:bg-gray-400 transition-colors"
          disabled={
            currentPage ===
            Math.ceil(Object.keys(groupedRecebiveis).length / itemsPerPage)
          }
        />
      </div>
    </div>
  );
}

// Definindo propTypes para validação de tipos
RecebiveisList.propTypes = {
  recebiveis: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      dataRecebimento: PropTypes.string.isRequired,
      nome: PropTypes.string,
      valor: PropTypes.number,
      status: PropTypes.string,
    })
  ).isRequired,
  onStatusChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default RecebiveisList;
